module.exports = __webpack_public_path__ + "static/media/G1-24-Jacee-Loris-cod55.58385172.png";